// import "react-image-gallery/styles/css/image-gallery.css";
// import ReactImageGallery from "react-image-gallery";
// import "styles/gallery.css";
import { useRef } from "react";
import clsx from "clsx";
import { PhotoProvider, PhotoView } from "react-photo-view";

import { EditIcon } from "components/icons";
import type { StoredFile } from "hooks/useProcessFiles";

import { ScrollNavigation } from "./ScrollNavigation"; // Adjust the import path as needed

import "react-photo-view/dist/react-photo-view.css";

// const images = [
//   { original: "/images/image.png", thumbnail: "/images/image.png" },
//   { original: "/images/image.png", thumbnail: "/images/image.png" },
//   { original: "/images/image.png", thumbnail: "/images/image.png" },
//   { original: "/images/image.png", thumbnail: "/images/image.png" },
//   { original: "/images/image.png", thumbnail: "/images/image.png" },
//   { original: "/images/image.png", thumbnail: "/images/image.png" },
// ];

// type IImageItem = {
//   original: string;
//   thumbnail: string;
// };

type ImageGalleryProps = {
  activeIndex: number;
  images: StoredFile[];
  editFileId?: string;
  setActiveIndex: (index: number) => void;
  onVisibleChange?: () => void;
};

export const ImageGallery: React.FC<ImageGalleryProps> = ({
  images,
  activeIndex,
  editFileId,
  setActiveIndex,
  onVisibleChange,
}) => {
  // const [imageItems, setImageItems] = useState<IImageItem[]>([]);

  const scrollContainerRef = useRef<HTMLDivElement>(null);

  // useEffect(() => {
  //   const items = images.map((path) => ({ original: path, thumbnail: path }));
  //   setImageItems(items);
  // }, [images]);

  // Calculate scroll distance dynamically (you can adjust this logic)
  const cardWidth = 100; // Width of each card
  const gap = 10; // Gap between cards (gap-8 = 2rem = 32px assuming 1rem = 16px)
  const scrollDistance = cardWidth + gap;

  if (!images || images?.length <= 0  || activeIndex >= images?.length) {
    return null;
  }

  return (
    <div>
      <div className="h-[300px] lg:h-[600px] bg-[#171717] flex flex-row items-center justify-center relative rounded-[8px]">
        {editFileId === images[activeIndex]?.id && (
          <div className="absolute top-0 right-0 p-2 bg-[rgba(0,0,0,0.30)] rounded-[4px] flex flex-row items-center justify-center gap-[10px] text-white">
            <EditIcon />
            <span className="text-[12px] font-medium">Editing</span>
          </div>
        )}
        {images[activeIndex]?.preview && (
          <PhotoProvider
            onVisibleChange={(visible) => visible && onVisibleChange?.()}
          >
            <PhotoView src={images[activeIndex]?.preview}>
              <img
                src={images[activeIndex]?.preview}
                alt="GENERATED"
                className="max-w-full max-h-full"
              />
            </PhotoView>
          </PhotoProvider>
        )}
      </div>
      <div className="mt-3">
        <ScrollNavigation
          scrollContainerRef={scrollContainerRef}
          scrollDistance={scrollDistance} // Pass the dynamic scroll distance
          className="flex flex-row self-stretch gap-3"
        >
          {images.map((image, index) => (
            <div
              className="w-[100px] h-[100px] flex flex-row items-center justify-center rounded-[4px] relative cursor-pointer flex-shrink-0"
              key={index}
              onClick={() => setActiveIndex(index)}
            >
              {index === activeIndex && editFileId === image.id && (
                <div className="absolute top-0 right-0 p-2 z-20 bg-[rgba(0,0,0,0.30)] rounded-[2px] cursor-default">
                  <EditIcon />
                </div>
              )}
              <div
                className={clsx(
                  "absolute inset-0 bg-black rounded-[4px] z-10",
                  {
                    "bg-opacity-50": index !== activeIndex,
                    "bg-opacity-0 border-[4px] border-solid border-[#4338CA] rounded-[8px]":
                      index === activeIndex,
                  }
                )}
              ></div>

              <img
                src={image.preview}
                alt="GENERATED"
                className="max-w-full max-h-full object-contain rounded-[8px]"
              />
            </div>
          ))}
        </ScrollNavigation>
      </div>
    </div>
  );
};
